import React from "react";
import { Link } from "react-router-dom";
import {
  Heart,
  Twitter,
  Github,
  Linkedin,
  Mail,
  ArrowRight,
  Globe,
  ShieldCheck
} from "lucide-react";

const FooterSection = () => {
  return (
    <footer className="footer-section">
      <div className="footer-container">
        <div className="footer-main-grid">
          {/* Brand & Newsletter Column */}
          <div className="footer-brand-col">
            <Link to="/" className="footer-logo">
              <div className="logo-icon-wrapper">
                <Heart className="logo-icon" size={24} fill="currentColor" />
              </div>
              <span className="logo-text gradient-text">Medico.in</span>
            </Link>
            <p className="brand-description">
              Revolutionizing connected healthcare through advanced IoT monitoring and AI-driven insights. Built for a healthier tomorrow.
            </p>

            <div className="footer-newsletter">
              <h4>Stay Updated</h4>
              <div className="newsletter-input-wrapper">
                <input type="email" placeholder="Enter your email" />
                <button className="newsletter-submit">
                  <ArrowRight size={18} />
                </button>
              </div>
            </div>

            <div className="footer-socials">
              <a href="#" className="social-link"><Twitter size={20} /></a>
              <a href="https://github.com/webdeveloperdesigner/Medico.in" className="social-link" target="_blank" rel="noopener noreferrer"><Github size={20} /></a>
              <a href="#" className="social-link"><Linkedin size={20} /></a>
              <a href="#" className="social-link"><Globe size={20} /></a>
            </div>
          </div>

          {/* Links Columns */}
          <div className="footer-links-grid">
            <div className="links-column">
              <h4>Platform</h4>
              <ul>
                <li><Link to="/features">Features</Link></li>
                <li><Link to="/about">How It Works</Link></li>
                <li><Link to="/specs">Technical Specs</Link></li>
                <li><Link to="/partnerships">Partnerships</Link></li>
              </ul>
            </div>

            <div className="links-column">
              <h4>Support</h4>
              <ul>
                <li><Link to="/help">Help Center</Link></li>
                <li><Link to="/documentation">Documentation</Link></li>
                <li><Link to="/contact">Contact Support</Link></li>
                <li><Link to="/ai">AI Assistant</Link></li>
              </ul>
            </div>

            <div className="links-column">
              <h4>Legal</h4>
              <ul>
                <li><Link to="/privacy">Privacy Policy</Link></li>
                <li><Link to="/terms">Terms of Service</Link></li>
                <li><Link to="/cookies">Cookie Policy</Link></li>
                <li><ShieldCheck size={14} className="inline-icon" /> <span>HIPAA Ready</span></li>
              </ul>
            </div>

            <div className="links-column">
              <h4>Company</h4>
              <ul>
                <li><Link to="/about">About Us</Link></li>
                <li><Link to="/team">Our Team</Link></li>
                <li><Link to="/coming-soon">Coming Soon</Link></li>
                <li><Link to="/updates">Release Notes</Link></li>
                <li><Link to="/partnerships">Partnerships</Link></li>
              </ul>
            </div>
          </div>
        </div>

        <div className="footer-bottom-bar">
          <div className="bottom-content">
            <p>© {new Date().getFullYear()} Medico.in | Global Connected Healthcare System</p>
            <div className="bottom-links">
              <Link to="/status">Status</Link>
              <span className="dot"></span>
              <Link to="/coming-soon">Security</Link>
              <span className="dot"></span>
              <Link to="/coming-soon">System Integrity</Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default FooterSection;
